export default __webpack_public_path__ + "static/media/BrainBreak cards30.63bd3bce.png";